var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99966 1.66577C14.6028 1.66577 18.3343 5.39731 18.3343 10.0004C18.3343 14.6035 14.6028 18.335 9.99966 18.335C5.39658 18.335 1.66504 14.6035 1.66504 10.0004C1.66504 5.39731 5.39658 1.66577 9.99966 1.66577ZM9.99966 2.91577C6.08693 2.91577 2.91504 6.08767 2.91504 10.0004C2.91504 13.9131 6.08693 17.085 9.99966 17.085C13.9124 17.085 17.0843 13.9131 17.0843 10.0004C17.0843 6.08767 13.9124 2.91577 9.99966 2.91577ZM9.99663 8.74959C10.313 8.74938 10.5747 8.98434 10.6163 9.28938L10.622 9.37418L10.625 13.9588C10.6253 14.304 10.3456 14.584 10.0004 14.5843C9.68403 14.5845 9.42238 14.3495 9.3808 14.0445L9.37504 13.9597L9.37204 9.375C9.37181 9.02982 9.65145 8.74982 9.99663 8.74959ZM10 5.83479C10.4597 5.83479 10.8323 6.20738 10.8323 6.66701C10.8323 7.12663 10.4597 7.49922 10 7.49922C9.54042 7.49922 9.16782 7.12663 9.16782 6.66701C9.16782 6.20738 9.54042 5.83479 10 5.83479Z",
    fill: "#2382F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e5b60aeb0f9d4e43a0cd3087ff756179.svg";
export { ForwardRef as ReactComponent };